// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import request from '@/utils/request';
export function login(data) {
  return request({
    url: '/admin/login',
    method: 'post',
    data: data
  });
}
export function getSmsCode(data) {
  return request({
    url: '/admin/sendCode',
    method: 'post',
    data: data
  });
}
export function loginSms(data) {
  return request({
    url: '/admin/loginSms',
    method: 'post',
    data: data
  });
}
export function loginSimulate(data) {
  return request({
    url: '/admin/loginSimulate',
    method: 'post',
    data: data
  });
}
export function getInfo(token) {
  return request({
    url: '/admin/getAdminInfoByToken',
    method: 'get',
    params: {
      token: token
    }
  });
}
export function logout() {
  return request({
    url: '/admin/logout',
    method: 'get'
  });
}

/**
 * 会员管理 列表
 * @param pram
 */
export function userListApi(params) {
  return request({
    url: "/admin/user/list",
    method: 'get',
    params: params
  });
}

/**
 * 会员管理 导出用户表（exportAll=true 时导出全部）
 * @param params
 */
export function exportUserListApi(params) {
  return request({
    url: "/admin/user/exportList",
    method: 'get',
    responseType: 'blob',
    isExcel: true,
    params: params
  });
}

/**
 * 新增普通会员
 * @param params
 */
export function addUsersApi(params) {
  return request({
    url: "/admin/user/addUsers",
    method: 'get',
    params: params
  });
}

/**
 * 会员管理 修改
 * @param pram
 */
export function userUpdateApi(params, data) {
  return request({
    url: "/admin/user/update",
    method: 'post',
    params: params,
    data: data
  });
}

/**
 * 会员管理等级 修改
 * @param pram
 */
export function userLevelUpdateApi(data) {
  return request({
    url: "/admin/user/update/level",
    method: 'post',
    data: data
  });
}

/**
 * 会员管理 详情
 * @param pram
 */
export function userInfoApi(params) {
  return request({
    url: "/admin/user/info",
    method: 'get',
    params: params
  });
}

/**
 * 会员管理 账户详情
 * @param pram
 */
export function infobyconditionApi(params) {
  return request({
    url: "/admin/user/infobycondition",
    method: 'get',
    params: params
  });
}

/**
 * 会员管理 账户详情top数据
 * @param pram
 */
export function topdetailApi(params) {
  return request({
    url: "/admin/user/topdetail",
    method: 'get',
    params: params
  });
}

/**
 * 会员管理 批量设置分组
 * @param pram
 */
export function groupPiApi(params) {
  return request({
    url: "/admin/user/group",
    method: 'post',
    params: params
  });
}

/**
 * 会员管理 批量设置标签
 * @param pram
 */
export function tagPiApi(params) {
  return request({
    url: "/admin/user/tag",
    method: 'post',
    params: params
  });
}

/**
 * 会员管理 积分余额
 * @param pram
 */
export function foundsApi(params) {
  return request({
    url: "/admin/user/operate/founds",
    method: 'get',
    params: params
  });
}

/**
 * 会员管理 删除
 * @param pram
 */
export function userDeleteApi(params) {
  return request({
    url: "/admin/user/delete",
    method: 'get',
    params: params
  });
}

/**
 * 获取启用的品牌会员列表
 */
export function getEnabledSupplierListApi(data) {
  return request({
    url: "/admin/dlm/supplier/list",
    method: 'post',
    data: data
  });
}

/**
 * 会员等级 列表
 * @param pram
 */
export function levelListApi() {
  return request({
    url: "/admin/system/user/level/list",
    method: 'get'
  });
}

/**
 * 会员等级 新增
 * @param pram
 */
export function levelSaveApi(data) {
  return request({
    url: "/admin/system/user/level/save",
    method: 'post',
    data: data
  });
}

/**
 * 会员等级 编辑
 *  @param pram
 */
export function levelUpdateApi(params, data) {
  return request({
    url: "/admin/system/user/level/update/".concat(params),
    method: 'post',
    // params,
    data: data
  });
}

/**
 * 会员等级 详情
 * @param pram
 */
export function levelInfoApi(params) {
  return request({
    url: "/admin/system/user/level/info",
    method: 'get',
    params: params
  });
}

/**
 * 会员等级 删除
 * @param pram
 */
export function levelDeleteApi(id) {
  return request({
    url: "/admin/system/user/level/delete/".concat(id),
    method: 'post'
  });
}

/**
 * 会员等级 是否显示
 * @param pram
 */
export function levelUseApi(data) {
  return request({
    url: "/admin/system/user/level/use",
    method: 'post',
    data: data
  });
}

/**
 * 会员标签 列表
 * @param pram
 */
export function tagListApi(params) {
  return request({
    url: "/admin/user/tag/list",
    method: 'get',
    params: params
  });
}

/**
 * 会员标签 新增
 * @param pram
 */
export function tagSaveApi(data) {
  return request({
    url: "/admin/user/tag/save",
    method: 'post',
    data: data
  });
}

/**
 * 会员标签 编辑
 * @param pram
 */
export function tagUpdateApi(params, data) {
  return request({
    url: "/admin/user/tag/update",
    method: 'post',
    params: params,
    data: data
  });
}

/**
 * 会员标签 详情
 * @param pram
 */
export function tagInfoApi(params) {
  return request({
    url: "/admin/user/tag/info",
    method: 'get',
    params: params
  });
}

/**
 * 会员标签 删除
 * @param pram
 */
export function tagDeleteApi(params) {
  return request({
    url: "/admin/user/tag/delete",
    method: 'get',
    params: params
  });
}

/**
 * 会员分组 列表
 * @param pram
 */
export function groupListApi(params) {
  return request({
    url: "/admin/user/group/list",
    method: 'get',
    params: params
  });
}

/**
 * 获取 DLM 会员列表
 * @param data
 */
export function dlmMemberListApi(data) {
  return request({
    url: '/admin/dlm/list',
    method: 'post',
    data: data
  });
}

/**
 * 导出 DLM 会员列表
 * @param data
 */
export function dlmMemberExportApi(data) {
  return request({
    url: '/admin/dlm/exportList',
    method: 'post',
    data: data,
    responseType: 'blob' // 处理文件流
  });
}

/**
 * 手动开通 DLM
 * @param data
 */
export function dlmOpenApi(data) {
  return request({
    url: '/admin/dlm/open',
    method: 'post',
    data: data
  });
}

/**
 * 查询合作过期的 DLM 会员（历史客户）
 * @param data
 */
export function expiredDlmMemberListApi(data) {
  return request({
    url: '/admin/dlm/expired/list',
    method: 'post',
    data: data
  });
}
/**
 * 赠送延长合作时间
 * @param data
 */
export function giftExtendDlmApi(data) {
  return request({
    url: '/admin/dlm/gift/extend',
    method: 'post',
    data: data
  });
}

/**
 * 查询用户项目管理/画布项目列表
 * @param data
 */
export function getUserProDetailApi(data) {
  return request({
    url: '/admin/dlm/user/proDetail',
    method: 'post',
    data: data
  });
}

/**
 * 分页查询用户协同设计项目列表（动图明细）
 * @param data
 */
export function getUserProPageApi(data) {
  return request({
    url: '/admin/dlm/user/projectPage',
    method: 'post',
    data: data
  });
}

/**
 * 获取邀约开通 DLM 会员链接
 */
export function dlmInviteLinkApi(data) {
  return request({
    url: '/admin/dlm/invite/link',
    method: 'post',
    data: data
  });
}

/**
 * 修改 DLM 备注
 * @param data
 */
export function dlmMarkUpdateApi(data) {
  return request({
    url: '/admin/dlm/mark/update',
    method: 'post',
    data: data
  });
}

/**
 * DLM 会员分组列表（登录获取工厂，不分页）
 */
export function dlmGroupListApi() {
  return request({
    url: '/admin/dlm/group/list',
    method: 'get'
  });
}

/**
 * DLM 会员分组 新增（同工厂内分组名称不可重复）
 * @param data
 */
export function dlmGroupSaveApi(data) {
  return request({
    url: '/admin/dlm/group/save',
    method: 'post',
    data: data
  });
}

/**
 * 会员分组 新增
 * @param pram
 */
export function groupSaveApi(data) {
  return request({
    url: "/admin/user/group/save",
    method: 'post',
    data: data
  });
}

/**
 * 会员分组 编辑
 * @param pram
 */
export function groupUpdateApi(params, data) {
  return request({
    url: "/admin/user/group/update",
    method: 'post',
    params: params,
    data: data
  });
}

/**
 * 会员分组 详情
 * @param pram
 */
export function groupInfoApi(params) {
  return request({
    url: "/admin/user/group/info",
    method: 'get',
    params: params
  });
}

/**
 * 会员分组 删除
 * @param pram
 */
export function groupDeleteApi(params) {
  return request({
    url: "/admin/user/group/delete",
    method: 'get',
    params: params
  });
}

/**
 *获取登录页图片
 */
export function getLoginPicApi() {
  return request({
    url: "/admin/getLoginPic",
    method: 'get'
  });
}

/**
 * @description 验证码
 */
export function captchaApi() {
  return request({
    url: "/admin/validate/code/get",
    method: 'get'
  });
}

/**
 * @description 修改上级推广人
 */
export function updateSpreadApi(data) {
  return request({
    url: "/admin/user/update/spread",
    method: 'post',
    data: data
  });
}

/**
 * @description 修改手机号
 */
export function updatePhoneApi(params) {
  return request({
    url: "/admin/user/update/phone",
    method: 'get',
    params: params
  });
}

/**
 * @description 新增分销商
 */
export function createMchPromoter(data) {
  return request({
    url: "/admin/user/createMchPromoter",
    method: 'post',
    data: data
  });
}

/**
 * @description 获取用户角色列表
 */
export function getRoleList(params) {
  return request({
    url: "/admin/user/findUserRoleList",
    method: 'get',
    params: params
  });
}

/**
 * @description 选定用户角色
 */
export function loginRole(data) {
  return request({
    url: "/admin/user/selectRole",
    method: 'post',
    data: data
  });
}

/**
 * 用户收货地址列表
 * @param pram
 */
export function addressList(params) {
  return request({
    url: "/admin/address/list",
    method: 'get',
    params: params
  });
}
/**
 * 根据搜索的生活达人导出Excel
 * @param pram
 */
export function exportUserByKeyWord(data) {
  return request({
    url: "/admin/user/exportUserByKeyWord",
    method: 'post',
    responseType: 'blob',
    isExcel: true,
    data: data
  });
}

/**
 * 导出小店报名清单
 * @param pram
 */
export function exportUserAll(data) {
  return request({
    url: "/admin/user/exportUserAll",
    method: 'post',
    responseType: 'blob',
    isExcel: true,
    data: data
  });
}